<kendo-dropdownlist
  [value]="value"
  [valuePrimitive]="true"
  [data]="processStates"
  textField="name"
  valueField="id"
  (valueChange)="onValueChange($event)"
  [popupSettings]="{ popupClass: 'popup-custom-style' }" />